import React from 'react'

type Props = {
  size: number
}

export const SpacerBlock: React.FC<Props> = ({ size }) => {
  return <div style={{ height: size + 'rem' }}></div>
}
